module.exports = __webpack_public_path__ + "img/game.350185d6.png";